// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1203":"c33682ca06eef7e7","5852":"9bcb07f1bd3d2af9"}[chunkId] + ".css";
};